import { cookie } from '@otto-ec/global-resources/cookie'
import { Apps, AppsPort, LoggingPort } from '../../../ports'
import { RetryStrategy } from '../../../utils'

declare global {
  interface Window {
    o_apps?: Apps
  }
}

export class AppsAdapter implements AppsPort {
  constructor(
    private readonly retryStrategy: RetryStrategy,
    private readonly logger: LoggingPort
  ) {}

  isApp(): boolean {
    /*                                                                     */
    return cookie.get('app') === 'true'
  }

  apps: () => Promise<Apps> = async () =>
    this.initAppsPromise().then((apps) => {
      this.apps = async () => apps
      return apps
    })

  private initAppsPromise() {
    return this.retryStrategy.run(
      () => {
        const oApps = window.o_apps
        if (typeof oApps === 'undefined' || oApps === null) {
          throw new Error('o_apps is undefined')
        }
        return oApps
      },
      (n, _error) => {
        this.logger.info(`o_apps is not defined after ${n} attempts.`)
      }
    )
  }
}
